import { useContext } from "react";
import { useQuery } from "react-query";
import { PermissionsContext } from "../contexts";
import { fetchPoliciesIfPermitted } from "../screens/deployment/policies/api";
import { useOrg } from "./useOrg";

/*
 * Returns query result with policies (and rulesets) from current selected org
 */
export const usePolicies = (withStats: boolean = true) => {
  const org = useOrg();
  const { permissions } = useContext(PermissionsContext);

  return useQuery(
    ["policies", { org, withStats }],
    () => fetchPoliciesIfPermitted(org?.id!, permissions, withStats),
    {
      enabled: !!org,
    }
  );
};
